import {courierDetail as _COURIERS_} from "@/config/courierCodes";
export default class Courier {
  static config = {
    BEE: "BEEExpress",
    CJLX: "CJLogisticShopX",
    FLE: "FlashExpress",
    FLEB: "FlashExpressBulky",
    FLEF: "FlashExpressFruit",
    FLEWP: "FlashExpressWarp",
    INT: "CourierInter",
    LAOS: "LAOCourier",
    JNT: "JAndTExpress",
    NJV: "Ninjavan",
    SCG: "SCGExpress",
    SCGC: "SCGCool",
    SCGF: "SCGFrozen",
    THP: "ThailandPost",
    TP2: "ThailandPost2",
    ECP: "ThailandEcoPost",
    EMST: "STTransport",
    EMSW: "EMSWarp",
    EMSX: "EMSXSevenTree",
    BEST: "BestExpress",
    TRUE: "TrueELogistics",
    TPSD: "Teleport",
    MSE: "MakesendExpress",
    MSEC: "MakesendExpressChilled",
    MSEF: "MakesendExpressFrozen",
    SPE: "ShippopExpress",
    DHL: "DHLExpress",
    SPEC: "ShippopExpressCool",
    KRYS: "KerryExpress",
    EMSXP: "SPRESS",
    SPXP: "ShopeeXpress",
    KRYQ: "KerryQuickExpress",
    ORNG: "KerryOrangeExpress",
    XPSO: "Xpresso",
    XPSD: "XpressoSameDay",
    GEN: "GenCourier",
    SPGEN: "SPGenCourier",
  };

  courierObj = [];

  setCourier(courier) {
    let courierCode = courier.toUpperCase();
    if (!this.courierObj.hasOwnProperty(courierCode)) {
      if (Courier.config.hasOwnProperty(courierCode)) {
        const courierName = Courier.config[courierCode];
        const courierClass = require(`@/courier/${courierName}`).default;
        this.courierObj[courierCode] = new courierClass();
      }
    }
    return this.courierObj[courierCode];
  }
}
